import { Box, Typography } from '@mui/material'
import { type ReactNode } from 'react'
import { styles } from './P2PAuthShell.styles'

/**
 * Shared two-column auth layout. Left: START branding + intro over a soft wavy-blue
 * field. Right: the form card (children), which delegates credential entry to
 * MiCredentials — START renders no password fields of its own.
 */
export const P2PAuthShell = ({ children }: { children: ReactNode }): JSX.Element => (
  <Box data-testid='p2pAuthShell' sx={styles.page}>
    <Box sx={styles.brandPanel}>
      <Box component='img' src='/STARTLogo.png' alt='START' sx={styles.logo} />
      <Typography variant='h3' sx={styles.brandHeading}>Peer to Peer Data Collection Request</Typography>
      <Typography variant='body1' sx={{ ...styles.brandCopy, mb: '16px' }}>
        START gathers Peer to Peer data each school year to better understand Peer to Peer implementation across
        Michigan. Your responses help us plan for future Peer to Peer training and support, communicate key information
        about Peer to Peer with the Michigan Department of Education, and much more.
      </Typography>
      <Typography variant='body1' sx={styles.brandCopy}>
        Thank you for sharing your Peer to Peer data with us!
      </Typography>
    </Box>

    <Box sx={styles.formPanel}>
      <Box sx={styles.formCard}>{children}</Box>
    </Box>
  </Box>
)
